import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectService } from '../../../services/project.service';
import { CommonModule } from '@angular/common';
import { BaseModalComponent } from '../../modals/base-modal/base-modal.component';
import { BaseAlertComponent } from '../../alerts/base-alert/base-alert.component';
import { Member } from '../../../dtos/member';

@Component({
  selector: 'app-add-researcher-modal',
  standalone: true,
  imports: [CommonModule, BaseModalComponent, BaseAlertComponent],
  templateUrl: './add-researcher-modal.component.html',
  styleUrls: ['./add-researcher-modal.component.scss'],
})
export class AddResearcherModalComponent implements OnInit {
  @Input() open = false;
  @Input() projectId: string = '';
  @Input() availableMembers: Member[] = [];
  @Output() openChange = new EventEmitter<boolean>();
  @Output() researcherAdded = new EventEmitter<any>();

  error: any = '';
  addingUserId: string | null = null;
  successMessage: string = '';
  addedMembers: Set<string> = new Set<string>();

  constructor(private projectService: ProjectService) {}

  ngOnInit(): void {}

  close() {
    this.open = false;
    this.error = '';
    this.successMessage = '';
    this.addingUserId = null;
    this.addedMembers.clear();
    this.openChange.emit(false);
  }

  addResearcher(member: Member): void {
    if (!member.user.id) {
      this.error = 'Invalid member selected';
      return;
    }
    this.addingUserId = member.user.id;
    this.error = '';
    this.successMessage = '';

    this.projectService
      .addResearcherToProject(this.projectId, member.user.id, 'RESEARCHER')
      .subscribe({
        next: () => {
          this.successMessage = `${this.getMemberName(member)} added successfully!`;
          this.addedMembers.add(member.user.id ?? '');
          this.researcherAdded.emit(member);
          this.addingUserId = null;
          // Clear success message after 2 seconds
          setTimeout(() => {
            this.successMessage = '';
          }, 2000);
        },
        error: (err) => {
          console.error('Could not add researcher', err);
          this.error =
            typeof err.error === 'object'
              ? err.error.error || err.error.detail || JSON.stringify(err.error)
              : err.error || 'Error adding researcher';
          this.addingUserId = null;
        },
      });
  }

  getMemberName(member: Member): string {
    const user = member.user;
    if (user.firstName || user.lastName) {
      return `${user.firstName || ''} ${user.lastName || ''}`.trim();
    }
    return user.fullName || user.email || 'Unknown';
  }

  isAddingMember(memberId: string): boolean {
    return this.addingUserId === memberId;
  }

  hasBeenAdded(memberId: string): boolean {
    return this.addedMembers.has(memberId);
  }

  getAvailableCount(): number {
    return this.availableMembers.length - this.addedMembers.size;
  }
}
